import { SpacerVertical, Typography } from '@klarna/bubble-ui';
import { Layout } from '@klarna/mp-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import { TrackImpression } from 'mage-insights';
import React from 'react';
import styled from 'styled-components';
import TrackableLink from '../../../components/TrackableLink';
import Plugin from '../../BoostPluginsPage/components/Plugin';
import { PLUGINS } from '../../constants';
const PLUGIN_OVERVIEW_PAGE = '/boost/plugins';
const plugins = PLUGINS.slice(0, 3);
const NoWrap = styled.span.withConfig({ displayName: "NoWrap", componentId: "sc-mpvczb" }) `
  white-space: nowrap;
`;
export default function PluginCarousel() {
    const t = i18nHooks.useTranslator();
    const event = {
        category: 'boost-home/plugin-carousel',
        action: 'impression'
    };
    return (React.createElement(TrackImpression, { event: event },
        React.createElement(SpacerVertical, { spaceToken: 'space.500' }),
        React.createElement(Typography, { textToken: 'text-style/headings/titles/bold/grande' },
            React.createElement(NoWrap, null, t('home-fe.boosters-home.plugin-carousel.title')),
            "\u00A0"),
        React.createElement(TrackableLink, { href: PLUGIN_OVERVIEW_PAGE, category: 'boost-home/plugin-carousel/all-platforms' },
            React.createElement(NoWrap, null, t('home-fe.boosters-home.plugin-carousel.overviewLink'))),
        React.createElement(SpacerVertical, { spaceToken: 'space.200' }),
        React.createElement(Layout.Grid, null,
            React.createElement(Layout.Section, { verticalSpacing: 'space.300', justifyContent: 'flex-start' }, plugins.map((plugin) => (React.createElement(Layout.Column, { key: plugin.id, desktopWidth: 4, tabletWidth: 6, mobileWidth: 12 },
                React.createElement(Plugin, { key: plugin.id, plugin: plugin, category: 'boost-home/plugin-carousel/platform' })))))),
        React.createElement(SpacerVertical, { spaceToken: 'space.200' }),
        React.createElement("div", null,
            React.createElement(Typography, { textToken: 'text-style/text/paragraphs/body/regular' },
                React.createElement(NoWrap, null, t('home-fe.boosters-home.plugin-carousel.directIntegrationLabel')),
                "\u00A0"),
            React.createElement(TrackableLink, { href: 'https://docs.klarna.com/klarna-payments/before-you-start/', openInNewWindow: true, category: 'boost-home/plugin-carousel/directly-integrated' },
                React.createElement(NoWrap, null, t('home-fe.boosters-home.plugin-carousel.directIntegrationLink'))))));
}
